module.exports = __webpack_public_path__ + "static/media/preview_general_campaign.37a1155b.svg";